export enum AvailableLanguages {
  EN = "en",
  ES = "es",
}

export interface Country {
  initials: string;
  "english-name": string;
  "spanish-name": string;
  d: string;
  "not-a-country"?: boolean;
  "has-multiple-path"?: boolean;
  "second-path"?: string;
  "third-path"?: string;
}
